'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsListStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabsListStyled = exports.TabsListStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TabsListStyled'
})(['display:flex;flex-grow:1;justify-content:center;', ';'], (0, _reactackleCore.transition)('transform'));

TabsListStyled.displayName = 'TabsListStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tabs/dist/styles/TabsListStyled.js
// module id = 824
// module chunks = 0